import React from 'react'
import { Center } from '@chakra-ui/react'
import { Link } from 'gatsby'
import { Icon } from '@chakra-ui/icons'
import { FaCheck, FaList } from 'react-icons/fa'
import { Button } from '@chakra-ui/react'
import { Box, Text, Flex } from '@chakra-ui/react'
import { UserRoutes } from '~config/routes'
import SharedStack from '~components/shared/wrappers/shared-stack'

export default function EmptyActionItems() {
    return (
        <Flex
            h="full"
            w="full"
            py={3}
            px={3}
            flexDir={{
                base: 'column',
            }}
            gridGap={{
                base: 4,
            }}
            bgGradient="linear(to-r, white, white, gray.50)"
            backdropBlur={'3xl'}
            rounded="xl"
            align="center"
            justify="space-between"
        >
            <SharedStack row>
                <Center px={3}>
                    <Icon as={FaCheck} boxSize="24px" color="brand.600" />
                </Center>
                <Box flex={1}>
                    <Text fontSize="md" color="gray.700" fontWeight="bold">
                        You're all caught up!
                    </Text>
                    <Text fontSize="xs" fontWeight="normal" color="gray.500">
                        No pending actions. New requests will appear here.
                    </Text>
                </Box>
                <Box>
                    <Button
                        as={Link}
                        size="xs"
                        leftIcon={<FaList />}
                        colorScheme="brand"
                        to={UserRoutes.PendingActions}
                    >
                        View all pending actions
                    </Button>
                </Box>
            </SharedStack>
        </Flex>
    )
}
